import CommonModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import "./EmailTab.css";
import email_send from "../../asset/image/email_send.svg";
import LabelValueDisplay from '../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay';

interface TestmailialogProps {
    testmailOpen: boolean;
    handleCancelTestmail: () => void;
    handleRecEmailChange: (e) => void;
    handleEmailSend: () => void;
    email: string;
    recMail: string;
    recMailValid: boolean;
}

const TestmailDialog = (props: TestmailialogProps) => {
    const {testmailOpen, handleCancelTestmail, handleRecEmailChange, handleEmailSend, email, recMail, recMailValid} = props;

    const element = (
        <div className="padding10">
            <img src={email_send} className="testmailStatusImage"></img>
            <div className="transfer-tab-grid recEmailDiv">
                <LabelValueDisplay
                    label="Sender Email"
                    value={email}
                />
            </div>
            <LabelValueDisplay
                label="Receiver Email"
                isInput
                value={recMail}
                onChange={(e) => {handleRecEmailChange(e)}}
                placeholder="Enter Email ID"
            />
        </div>
    )
    return(
        <CommonModal
            open={testmailOpen}
            onClose={handleCancelTestmail}
            onSave={handleEmailSend}
            title={"Test Email"}
            saveText={"Send"}
            disableSave={!recMailValid}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"408px"}
            height={"280px"}
        />
    )
}

export default TestmailDialog;